import * as _ from "lodash";
import * as Backbone from "backbone";
import {Module, SensorRecord} from "../../../models/Module";
import {PermissionCollection} from "../../../collections/Permissions";
import {SensorConfig} from "../../../models/SensorConfig";
import {ConversionFunctionCollection} from "../../../collections/ConversionFunctions";
import {ChannelParamCollection} from "../../../collections/ChannelParams";
import {BaseView} from "../../_BaseViews";
import {User} from "../../../models/User";
import ViewOptions = Backbone.ViewOptions;

interface SensorConfigsToCreate {
    sensor_id: number,
    type: string,
    value: number
}

interface ChannelToCreate {
    sensor_id: number;
    name: string;
    position: number;
    unit: string;
    decimals: number;
    conversion_function_id: number;
}

interface ChannelToUpdate {
    id: number;
    position: number;
    oldPosition?: number;
    name: string;
    unit: string;
    decimals: number;
    conversion_function_id: number;
}

interface ChannelParamToUpdate {
    id: number;
    value: number;
}

interface ChannelParamToCreate {

}

export interface BaseSensorConfigViewOptions extends ViewOptions<Backbone.Model> {
    config: SensorConfig[],
    module: Module,
    con: SensorRecord,
    permissionCollection: PermissionCollection,
    conversionFunctionCollection: ConversionFunctionCollection,
    channelParamCollection: ChannelParamCollection,
    installId: number,
    sensorId: number,
    orgId: number,
    currentUser: User,
    organizationCollection?: any,
    installCollection?: any
}

export class BaseSensorConfigView extends BaseView {

    config: Backbone.Collection<SensorConfig>;
    module: Module;
    con: SensorRecord;
    permissionCollection: PermissionCollection;
    conversionFunctionCollection: ConversionFunctionCollection;
    channelParamCollection: ChannelParamCollection;
    installId: number;
    sensorId: number;
    orgId: number;
    currentUser: User;

    constructor(options: BaseSensorConfigViewOptions) {
        super(options);

        this.config = new Backbone.Collection(options.config);
        this.module = options.module;
        this.con = options.con;
        this.permissionCollection = options.permissionCollection;
        this.conversionFunctionCollection = options.conversionFunctionCollection;
        this.channelParamCollection = options.channelParamCollection;
        this.installId = options.installId;
        this.sensorId = options.sensorId;
        this.orgId = options.orgId;
        this.currentUser = options.currentUser;
    };

    validate() {
        return false
    };

    getExistingChannels() {
        var existing = {};
        var channels = _.sortBy(this.con['channels'], (c) => {
            return c['channel_position']
        });
        _.each(channels, (channel) => {
            existing[channel['channel_id']] = channel;
        });
        return existing;
    }

    hasUpdatedConfig() {
        return false
    };

    prepareForSaving() {
    };

    getConfig(): SensorConfigsToCreate[] {
        return []
    }

    getActionPackets() {
        return []
    }

    getUpdatedChannels(): {
        create: ChannelToCreate[],
        update: { [id: number]: ChannelToUpdate; },
        'delete': number[],
    } {
        return {create: [], update: {}, 'delete': []}
    }

    getUpdatedChannelParams(): {
        create: ChannelParamToCreate[],
        update: { [id: number]: ChannelParamToUpdate; },
        'delete': number[],
    } {
        return {create: [], update: {}, 'delete': []}
    }

    getUpdatedSensorProperties(): { [propertyName: string]: any } {
        return {}
    }
}

export class BaseModuleConfigView extends BaseSensorConfigView {

    template = _.template(require('templates/settings/sensor_config/basemodule.html'));

    connector: number;
    isGateway: boolean;
    lastPanId: number;

    constructor(options: BaseSensorConfigViewOptions) {
        super(_.extend({
            events: {
                'change .settings-sensorconfig-module-outdoors': 'handleChangeOutdoors'
            }
        }, options));

        this.connector = 0;
        this.lastPanId = this.module.getChannelValue(0, 7, 0);
        this.isGateway = this.module.isGateway();
    }

    render() {
        const hasIAQSensors = this.module.get('sensors').some(sensor => sensor.sensor_type === 34);
        
        let moduleOutdoorsValue = false;
        if (hasIAQSensors) {
            const iaqSensor = this.module.get('sensors').find(sensor => sensor.sensor_type === 34);
            if (iaqSensor) {
                const isOutdoorsValue = iaqSensor.is_outdoors;
                moduleOutdoorsValue = isOutdoorsValue === true || Number(isOutdoorsValue) === 1 || String(isOutdoorsValue) === "1";
            }
        }

        this.$el.html(this.template({
            module: this.module,
            moduleNumber: Number(this.module.get('module_number')),
            permissionCollection: this.permissionCollection,
            installId: this.installId,
            isGateway: this.isGateway,
            hasIAQSensors: hasIAQSensors,
            moduleOutdoorsValue: moduleOutdoorsValue
        }));

        return this;
    }

    getModuleLocation(): string {
        return (<string> this.$('.settings-sensorconfig-module-location').val()).trim();
    }

    getModuleOutdoorsValue(): boolean {
        const elem = this.$('.settings-sensorconfig-module-outdoors');
        return elem.length > 0 ? elem.is(':checked') : false;
    }

    handleChangeOutdoors(e: JQuery.UIEventBase) {
        const isOutdoors = this.getModuleOutdoorsValue();
        const newSensorName = isOutdoors ? "Outdoor Air Quality" : "Indoor Air Quality";
        
        $('.settings-sensorconfig-sensor-title .sensor-title-text').each((index, element) => {
            const $textElement = $(element);
            const currentText = $textElement.text().trim();
            
            if (currentText.toLowerCase() === "indoor air quality" || 
                currentText.toLowerCase() === "outdoor air quality") {
                $textElement.text(newSensorName);
            }
        });
    }


    validate() {
        return true
    }

}


// WEBPACK FOOTER //
// ./srv/public/js/views/settings/sensor_config/_BaseSensorConfigView.ts